import React from 'react';

import Navbar from './DefaultLayout/Navbar';
import { createUseStyles } from 'react-jss';

export interface DefaultLayoutProps {
  history?: any;
  breadCrumb?: any[]
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ history, breadCrumb, children }) => {
  const classes = useStyles();
  return (
    <>
      <Navbar history={history} breadCrumb={breadCrumb} />
      <main className={classes.main}>{children}</main>
    </>
  );
};

const useStyles = createUseStyles({
  main: {
    backgroundColor: '#FBFBFB',
    paddingBottom: '80px',
    maxWidth:'1490px',
    margin : '0 auto',
    
  },
  
});

export default DefaultLayout;
